import VueI18n from 'vue-i18n';

import en from './en';
import zhCN from './zh-CN';
import ar from './ar';
import es from './es';
import fr from './fr';
import ru from './ru';
import { getLocalItem, setLocalItem } from '@/utils/utils';

export const messages = {
  en: en,
  'zh-CN': zhCN,
  ar,
  es,
  fr,
  ru
};

export const langs = Object.keys(messages);

const defaultLang = 'zh-CN';

let i18n = null;

/**
 * 获取当前
 * @returns {keyof typeof messages}
 */
function getLang() {
  let lang = getLocalItem('lang');

  if (!lang) {
    if (navigator.language.startsWith('zh')) {
      lang = 'zh-CN';
    } else {
      lang = 'en';
    }
  }

  lang = setLang(lang);

  return lang;
}

/**
 * 设置当前显示语言
 * @param {keyof typeof messages} lang
 * @returns
 */
function setLang(lang) {
  const l = langs.includes(lang) ? lang : defaultLang;

  if (i18n && l === i18n.locale) return l;

  setLocalItem('lang', l);

  if (i18n) i18n.locale = l;

  langBus.emit();

  return l;
}

const langBus = {
  listeners: [],
  on(fn) {
    this.listeners.push(fn);
  },
  off(fn) {
    this.listeners = this.listeners.filter(f => f !== fn);
  },
  emit() {
    this.listeners.forEach(fn => fn());
  }
};

// Create VueI18n instance with options
i18n = new VueI18n({
  locale: getLang(), // set locale
  messages // set locale messages
});

export { i18n, setLang, getLang, langBus };
